var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-title"},[(_vm.title)?_c('span',{domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_c('div',{staticClass:"fr"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }